(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialise = (scope = document) => scope.querySelectorAll('[data-gml-contact]').forEach(root => {
    if (root.dataset.contactReady) return;
    root.dataset.contactReady = 'true';
    const form = root.querySelector('form');
    const phone = root.querySelector('[data-contact-phone]');
    const phoneError = root.querySelector('[data-contact-phone-error]');
    if (phone) {
      const validatePhone = (showError = false) => {
        const value = phone.value.trim();
        const digits = value.replace(/\D/g, '');
        const valid = /^\+?[0-9 .()-]+$/.test(value) && digits.length >= 7 && digits.length <= 15;
        phone.setCustomValidity(valid ? '' : phone.dataset.phoneError);
        if (valid) {
          phone.removeAttribute('aria-invalid');
          if (phoneError) phoneError.hidden = true;
        } else if (showError) {
          phone.setAttribute('aria-invalid', 'true');
          if (phoneError) phoneError.hidden = false;
        }
        return valid;
      };
      phone.addEventListener('input', () => validatePhone(phone.getAttribute('aria-invalid') === 'true'));
      phone.addEventListener('change', () => validatePhone(true));
      phone.addEventListener('blur', () => validatePhone(true));
      phone.addEventListener('invalid', () => validatePhone(true));
      form?.addEventListener('submit', event => {
        if (!validatePhone(true)) {
          event.preventDefault();
          phone.reportValidity();
        }
      });
      form?.addEventListener('reset', () => requestAnimationFrame(() => {
        phone.removeAttribute('aria-invalid');
        if (phoneError) phoneError.hidden = true;
        validatePhone();
      }));
      validatePhone();
    }
    const message = root.querySelector('[data-contact-message]');
    const counter = root.querySelector('[data-contact-count]');
    const limitStatus = root.querySelector('[data-contact-limit-status]');
    if (message && counter) {
      let composing = false;
      let atLimit = false;
      const updateCount = () => {
        const maximum = message.maxLength;
        if (!composing && message.value.length > maximum) {
          let trimmed = message.value.slice(0, maximum);
          const lastCode = trimmed.charCodeAt(trimmed.length - 1);
          if (lastCode >= 0xD800 && lastCode <= 0xDBFF) trimmed = trimmed.slice(0, -1);
          message.value = trimmed;
        }
        const count = message.value.length;
        const reached = count >= maximum;
        counter.textContent = counter.dataset.countTemplate.replace('__COUNT__', count.toLocaleString(document.documentElement.lang || 'en'));
        counter.dataset.limitReached = String(reached);
        if (limitStatus && reached !== atLimit) limitStatus.textContent = reached ? limitStatus.dataset.limitMessage : '';
        atLimit = reached;
      };
      message.addEventListener('compositionstart', () => { composing = true; });
      message.addEventListener('compositionend', () => { composing = false; updateCount(); });
      message.addEventListener('input', updateCount);
      message.addEventListener('change', updateCount);
      root.querySelector('form')?.addEventListener('reset', () => requestAnimationFrame(updateCount));
      updateCount();
    }
    const subject = root.querySelector('[data-contact-subject]');
    if (subject && !subject.value) {
      const suggested = new URL(location.href).searchParams.get('subject');
      if (suggested) {
        const match = [...subject.options].find(option => option.value.toLowerCase() === suggested.toLowerCase());
        if (match) subject.value = match.value;
      }
    }
    const reset = root.querySelector('[data-contact-reset]');
    if (reset) {
      const cleanURL = new URL(reset.href, location.origin);
      const currentURL = new URL(location.href);
      ['preview_theme_id', 'country', 'currency', 'locale'].forEach(key => {
        if (currentURL.searchParams.has(key)) cleanURL.searchParams.set(key, currentURL.searchParams.get(key));
      });
      reset.href = cleanURL.pathname + cleanURL.search;
    }
    const feedback = root.querySelector('[data-contact-feedback]');
    if (feedback) requestAnimationFrame(() => { feedback.focus({ preventScroll: true }); feedback.scrollIntoView({ block: 'center', behavior: 'instant' }); });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialise()); else initialise();
  document.addEventListener('shopify:section:load', event => initialise(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gml-accessories"]) return;
  try {
    
  (() => {
    const focusResult = (root) => {
      const result = root.querySelector('.gml-accessories-launch [data-gml-launch-result]');
      if (result) result.focus({ preventScroll: true });
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => focusResult(document), { once: true });
    } else {
      focusResult(document);
    }
    document.addEventListener('shopify:section:load', (event) => focusResult(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gml-account-gateway"] && !Shopify.designMode) return;
  try {
    
(() => {
  const updateCounts = () => document.querySelectorAll('[data-gml-client-count]').forEach(node => {
    const history = node.dataset.gmlClientCount === 'history';
    try {
      if (history && window.Shopify?.customerPrivacy?.preferencesProcessingAllowed?.() !== true) { node.hidden = true; return; }
      const entries = JSON.parse(localStorage.getItem(history ? 'gml_watch_history_v1' : 'blano_favorites') || '[]');
      if (!Array.isArray(entries)) throw new Error('Invalid selection');
      const ids = new Set();
      for (const entry of entries) {
        if (!entry || !/^\d+$/.test(String(entry.id))) continue;
        if (history) {
          if (typeof entry.title !== 'string' || !Number.isFinite(entry.viewedAt) || entry.viewedAt <= 0 || entry.viewedAt > 8640000000000000) continue;
          const url = new URL(entry.url, location.origin);
          if (url.origin !== location.origin || !/\/products\/[a-z0-9][a-z0-9-]*\/?$/i.test(url.pathname)) continue;
        }
        ids.add(String(entry.id));
      }
      node.textContent = node.dataset.countTemplate.replace('__COUNT__', ids.size.toLocaleString(document.documentElement.lang || 'en'));
      node.hidden = false;
    } catch { node.hidden = true; }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', updateCounts); else updateCounts();
  window.addEventListener('pageshow', updateCounts);
  window.addEventListener('storage', event => { if (!event.key || ['blano_favorites', 'gml_watch_history_v1'].includes(event.key)) updateCounts(); });
  document.addEventListener('gml:wishlist-change', updateCounts);
  document.addEventListener('gml:history-change', updateCounts);
  document.addEventListener('visitorConsentCollected', updateCounts);
  document.addEventListener('shopify:section:load', updateCounts);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gml-explore"] && !Shopify.designMode) return;
  try {
    
(() => {
  function mount(root) {
    if (root.dataset.mounted) return;
    root.dataset.mounted = 'true';
    const catalogue = JSON.parse(root.querySelector('[data-gml-catalogue]').textContent);
    const data = catalogue.map(brand => ({ ...brand, models: [...brand.models] }));
    const labels = JSON.parse(root.querySelector('[data-explore-labels]').textContent);
    const overrides = new Map(JSON.parse(root.querySelector('[data-explore-overrides]').textContent).filter(item => item.key).map(item => [item.key, item]));
    const displayName = (item, key) => item.libraryBlock ? (typeof item.displayName === 'string' ? item.displayName : item.name) : overrides.get(key)?.title || item.displayName || item.name;
    const displayDescription = (item, key) => item.libraryBlock ? item.description : overrides.get(key)?.hideDescription ? '' : overrides.get(key)?.description || item.description;
    const media = new Map();
    root.querySelectorAll('[data-explore-media] template').forEach(template => media.set(template.dataset.catalogueKey, template));
    const originalMedia = new Map(media);
    const libraryBlocks = new Map();
    let selectedEditorBlock = '';
    const inEditor = root.dataset.editorMode === 'true' || Boolean(window.Shopify?.designMode);
    const editorStorageKey = 'gml-model-preview:' + root.dataset.editorKey;
    const readEditorSelection = () => {
      if (!inEditor) return null;
      try { return JSON.parse(sessionStorage.getItem(editorStorageKey) || 'null'); } catch (_) { return null; }
    };
    const saveEditorSelection = selection => {
      if (!inEditor) return;
      try { sessionStorage.setItem(editorStorageKey, JSON.stringify(selection)); } catch (_) {}
    };
    function hydrateLibraries() {
      if (root.dataset.modelLibraries !== 'true') return;
      libraryBlocks.clear();
      media.clear();
      originalMedia.forEach((template, key) => { if (!key.includes('/')) media.set(key, template); });
      data.forEach(brand => { brand.models = []; });
      const seen = new Set();
      document.querySelectorAll('[data-gml-model-library]').forEach(library => {
        const payload = JSON.parse(library.querySelector('[data-model-library-data]').textContent);
        const brand = data.find(item => item.slug === payload.brand);
        const canonicalBrand = catalogue.find(item => item.slug === payload.brand);
        if (!brand || !canonicalBrand) return;
        payload.blocks.forEach(block => {
          const definition = canonicalBrand.models.find(item => item.slug === block.slug);
          if (!definition) return;
          const key = brand.slug + '/' + definition.slug;
          if (seen.has(key)) return;
          seen.add(key);
          const template = [...library.querySelectorAll('[data-model-library-block]')].find(item => item.dataset.modelLibraryBlock === block.id);
          const model = { ...definition, displayName: typeof block.title === 'string' ? block.title : definition.name, description: block.showDescription ? block.description || '' : '', libraryBlock: block.id, librarySection: payload.sectionId, enabled: payload.enabled !== false && block.enabled !== false, autoImage: block.autoImage !== false, imageScale: Math.max(50, Math.min(140, Number(block.imageScale) || 100)) };
          brand.models.push(model);
          libraryBlocks.set(block.id, { brand, model, template });
          if (template?.content.querySelector('img')) media.set(key, template);
        });
      });
    }
    hydrateLibraries();
    const grid = root.querySelector('[data-explore-grid]');
    const title = root.querySelector('[data-explore-title]');
    const more = root.querySelector('[data-model-more]');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const backdrop = root.querySelector('[data-gml-page-backdrop]');
    const generalBackground = backdrop.querySelector('img')?.cloneNode(true);
    let backgroundRevision = 0;
    function updateBackground() {
      const revision = ++backgroundRevision;
      const brandImage = current && root.dataset.useBrandBackground === 'true' ? media.get(current.slug)?.content.querySelector('img') : null;
      const source = brandImage || generalBackground;
      if (!source) {
        backdrop.querySelectorAll('img').forEach(image => image.remove());
        return;
      }
      const existing = Array.from(backdrop.querySelectorAll('img')).at(-1);
      if (existing?.getAttribute('src') === source.getAttribute('src')) return;
      const image = source.cloneNode(true);
      image.className = 'gml-page-backdrop__image';
      image.loading = 'eager';
      image.fetchPriority = 'auto';
      image.sizes = '100vw';
      image.alt = '';
      const show = () => {
        if (revision !== backgroundRevision || !root.isConnected) return;
        const previous = Array.from(backdrop.querySelectorAll('img'));
        backdrop.append(image);
        if (reducedMotion.matches || !image.animate) { previous.forEach(item => item.remove()); return; }
        image.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 480, easing: 'ease-out' }).finished.then(() => previous.forEach(item => item.remove())).catch(() => {});
      };
      if (image.decode) image.decode().then(show).catch(() => {});
      else { image.onload = show; if (image.complete) show(); }
    }
    const incoming = new URL(location.href);
    const value = incoming.searchParams.get('gml_max');
    let maxPrice = value !== null && Number.isFinite(Number(value)) && Number(value) >= 0 ? Number(value) : null;
    const lowerValue = incoming.searchParams.get('gml_min');
    let minPrice = lowerValue !== null && Number.isFinite(Number(lowerValue)) && Number(lowerValue) >= 0 ? Number(lowerValue) : 0;
    if(maxPrice !== null && minPrice > maxPrice) minPrice = maxPrice;
    let current = null, limit = 6;
    const el = (tag, cls, text) => { const n = document.createElement(tag); if(cls) n.className=cls; if(text) n.textContent=text; return n; };
    const exclusion = ' NOT product_type:"Accessories" NOT product_type:"Eyewear" NOT product_type:"Jewelry" NOT product_type:"Jewellery"';
    function inventoryURL(brand, model) {
      const path = brand ? root.dataset.searchUrl : root.dataset.inventoryUrl;
      const u = new URL(window.GmlLocale?.url(path) || path, location.origin);
      const currentURL = new URL(location.href);
      ['preview_theme_id','preview_key','_fd','pb','country','currency','locale'].forEach(key => { if(currentURL.searchParams.has(key)) u.searchParams.set(key, currentURL.searchParams.get(key)); });
      u.searchParams.set('type','product');
      u.searchParams.set('view',brand ? 'gml-results' : 'gml-inventory');
      u.searchParams.set('gml_scope','watches');
      const vendorQuery = brand ? 'vendor:"'+brand.name.toUpperCase()+'"' : '('+data.map(b=>'vendor:"'+b.name.toUpperCase()+'"').join(' OR ')+')';
      if (brand) u.searchParams.set('q', '('+(model ? model.query : vendorQuery)+')'+exclusion);
      u.searchParams.set('options[prefix]','none');
      if(brand) { u.searchParams.set('gml_brand',brand.slug); u.searchParams.set('gml_brand_title',displayName(brand,brand.slug)); }
      if(model) { u.searchParams.set('gml_model',model.slug); u.searchParams.set('gml_model_title',displayName(model,brand.slug+'/'+model.slug)); }
      if(minPrice > 0) u.searchParams.set('gml_min', String(minPrice));
      if(maxPrice !== null) u.searchParams.set('gml_max', String(maxPrice));
      return u.pathname+u.search;
    }
    const svg = '<svg class="gml-explore__watch" viewBox="0 0 120 220" fill="none" aria-hidden="true"><path d="M38 4h44l5 65H33L38 4Zm-5 147h54l-5 65H38l-5-65Z" fill="#cecece" stroke="#8e8e8e"/><path d="M39 17h42M38 30h44M37 43h46M36 56h48M36 164h48M37 177h46M38 190h44M39 203h42" stroke="#b0b0b0"/><rect x="104" y="101" width="9" height="17" rx="2" fill="#adadad"/><circle cx="60" cy="110" r="47" fill="#e7e7e7" stroke="#9e9e9e" stroke-width="3"/><circle cx="60" cy="110" r="40" fill="#f6f6f6" stroke="#b8b8b8"/><path d="M60 75v6m0 58v6m-35-35h6m58 0h6M35 85l4 4m42 42 4 4M35 135l4-4m42-42 4-4M60 110 45 94m15 16 20-26" stroke="#7f7f7f" stroke-width="2" stroke-linecap="round"/><circle cx="60" cy="110" r="3" fill="#7f7f7f"/></svg>';
    function visual(key, brand, model) {
      const box = el('div','gml-explore__visual');
      const template = media.get(key);
      if(template) {
        box.append(template.content.cloneNode(true));

      }
      else if(model) box.innerHTML=svg;
      else box.append(el('span','gml-explore__monogram',brand.monogram));
      box.setAttribute('aria-hidden','true');
      return box;
    }
    const productMediaRequests = new Map();
    const modelText = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
    function loadProductMedia(brand) {
      if (productMediaRequests.has(brand.slug) || brand.models.every(model => model.autoImage === false || media.has(brand.slug + '/' + model.slug))) return;
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 20000);
      const url = new URL(inventoryURL(brand), location.origin);
      url.searchParams.set('view', 'gml-price-data');
      url.searchParams.delete('gml_min');
      url.searchParams.delete('gml_max');
      productMediaRequests.set(brand.slug, fetch(url, { credentials: 'same-origin', signal: controller.signal }).then(response => {
        if (!response.ok) throw new Error('Unavailable');
        return response.json();
      }).then(payload => {
        if (payload.version !== 1 || !Array.isArray(payload.items)) return;
        brand.models.forEach(model => {
          const key = brand.slug + '/' + model.slug;
          if (model.autoImage === false || media.has(key)) return;
          const labels = [model.name, ...model.aliases].map(modelText).filter(Boolean);
          const item = payload.items.find(product => {
            const explicitModel = modelText(product.model);
            return product.image && explicitModel && modelText(product.vendor) === modelText(brand.name) && labels.some(label => (' ' + explicitModel + ' ').includes(' ' + label + ' '));
          });
          if (!item) return;
          const imageURL = new URL(item.image, location.origin);
          if (!['https:', 'http:'].includes(imageURL.protocol)) return;
          const template = document.createElement('template');
          const image = document.createElement('img');
          image.src = imageURL.href;
          image.alt = '';
          image.loading = 'lazy';
          image.width = 900;
          image.height = 1125;
          template.content.append(image);
          media.set(key, template);
          root.querySelectorAll('[data-catalogue-card]').forEach(card => {
            if (card.dataset.catalogueCard === key) card.querySelector('.gml-explore__visual')?.replaceChildren(template.content.cloneNode(true));
          });
        });
      }).catch(() => {}).finally(() => clearTimeout(timeout)));
    }
    function card(brand, model) {
      const a = el('a','gml-explore__card '+(model?'gml-explore__card--model':'gml-explore__card--brand'));
      a.href = model ? inventoryURL(brand,model) : '#'+brand.slug;
      a.dataset.catalogueCard = brand.slug+(model?'/'+model.slug:'');
      if (model?.libraryBlock) {
        const record = libraryBlocks.get(model.libraryBlock);
        const attributes = record?.template?.getAttribute('data-shopify-editor-block');
        if (attributes) a.setAttribute('data-shopify-editor-block', attributes);
        a.dataset.modelEditorBlock = model.libraryBlock;
        a.style.setProperty('--gml-model-image-scale', String(model.imageScale / 100));
        if (!model.enabled) a.classList.add('gml-explore__card--editor-hidden');
      }
      const copy = el('div','gml-explore__copy');
      if(model && model.era==='legacy') copy.append(el('span','gml-explore__archive',labels.archive));
      const key = brand.slug + (model ? '/' + model.slug : '');
      const item = model || brand;
      copy.append(el('h2', '', displayName(item, key)));
      const description = displayDescription(item, key);
      if (description) copy.append(el('p', '', description));
      copy.append(el('span','gml-explore__choose',model?labels.view:labels.choose));
      a.append(copy,visual(brand.slug+(model?'/'+model.slug:''),brand,model));
      return a;
    }
    const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if(!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        if(reducedMotion.matches || !entry.target.animate) return;
        const delay=entry.target.getBoundingClientRect().top<innerHeight ? Number(entry.target.dataset.revealDelay||0) : 0;
        entry.target.animate([{opacity:0,transform:'translateY(24px)'},{opacity:1,transform:'translateY(0)'}],{duration:650,delay,easing:'cubic-bezier(.2,.65,.25,1)',fill:'backwards'});
      });
    },{threshold:.08}) : null;
    function reveal(cards, start) {
      cards.forEach((card,index)=>{
        if(index<start || !observer || reducedMotion.matches) return;
        card.dataset.revealDelay=String(Math.min((index-start)*65,195));
        observer.observe(card);
      });
    }
    function renderGrid(appendOnly=false) {
      const models=current ? current.models.filter(m=>m.enabled !== false || inEditor && m.libraryBlock === selectedEditorBlock) : [];
      const shown=models.slice(0,limit);
      const previous=appendOnly?grid.children.length:0;
      const items=current?shown:data;
      const fragment=document.createDocumentFragment();
      items.slice(previous).forEach(item=>fragment.append(current?card(current,item):card(item)));
      if(appendOnly) grid.append(fragment);
      else { if(observer) observer.disconnect(); grid.replaceChildren(fragment); }
      grid.classList.toggle('gml-explore__grid--brands',!current);
      reveal(Array.from(grid.children),previous);
      more.hidden=!current || shown.length>=models.length;
      root.querySelector('[data-explore-empty]').hidden=!current || models.length>0;
      root.querySelector('[data-explore-status]').textContent=current?shown.length+' '+labels.shown:'';
    }
    function route(focus) {
      const slug=location.hash.slice(1);
      const backArrow = root.querySelector('[data-gml-back]');
      if (backArrow) { const fallback = data.some(item => item.slug === slug) ? '#brands' : '/'; backArrow.href = fallback; backArrow.dataset.gmlBackFallback = fallback; }
      current=data.find(b=>b.slug===slug)||null;limit=6;
      root.classList.toggle('gml-explore--brand-selection',!current);
      title.textContent=current?displayName(current,current.slug):labels.title;
      updateBackground();
      const description = root.querySelector('[data-explore-description]');
      description.textContent=current?displayDescription(current,current.slug):labels.description;
      description.hidden=!labels.showDescription || !description.textContent;
      const eyebrow = root.querySelector('[data-explore-eyebrow]');
      eyebrow.textContent=current?labels.models:labels.eyebrow;
      eyebrow.hidden=!(current?labels.showModelEyebrow:labels.showEyebrow) || !eyebrow.textContent;
      root.querySelector('[data-brand-inventory]').hidden=false;
      root.querySelector('[data-inventory-link-label]').textContent=current?labels.inventory:labels.viewAll;
      root.querySelector('[data-model-note]').hidden=!current || !labels.showNote;
      const crumb=root.querySelector('[data-current-crumb]');
      crumb.hidden=!current;crumb.textContent=current?'/ '+displayName(current,current.slug):'';
      if(current) crumb.setAttribute('aria-current','page'); else crumb.removeAttribute('aria-current');
      const all=root.querySelector('[data-all-brands]');
      if(current) all.removeAttribute('aria-current'); else all.setAttribute('aria-current','page');
      root.querySelector('[data-brand-inventory]').href=inventoryURL(current);
      renderGrid();
      if(current) loadProductMedia(current);
      if(focus){title.focus({preventScroll:true});window.scrollTo({top:0,behavior:'instant'});}
    }
    root.addEventListener('gml:price-change',event=>{
      const nextMin=event.detail?.minPrice;
      const nextMax=event.detail?.maxPrice;
      minPrice=typeof nextMin==='number' && Number.isFinite(nextMin) && nextMin>=0?nextMin:0;
      maxPrice=typeof nextMax==='number' && Number.isFinite(nextMax) && nextMax>=0?nextMax:null;
      if(maxPrice!==null && minPrice>maxPrice) minPrice=maxPrice;
      const destination = inventoryURL(current);
      window.location.assign(window.GmlLocale?.url(destination) || destination);
    });
    root.addEventListener('gml:price-reset',()=>{
      minPrice=0;maxPrice=null;
      const resetURL=new URL(location.href);
      Array.from(resetURL.searchParams.keys()).forEach(key=>{
        if(['q','gml_text','gml_min','gml_max','gml_brand','gml_model','gml_scope','page','sort_by','type'].includes(key) || key.startsWith('filter.') || key.startsWith('options[')) resetURL.searchParams.delete(key);
      });
      resetURL.hash='';
      history.replaceState(history.state,'',resetURL.pathname+resetURL.search);
      route(true);
      root.querySelector('[data-gml-price]')?.dispatchEvent(new CustomEvent('gml:price-sync',{detail:{minPrice:0,maxPrice:null}}));
    });
    more.addEventListener('click',()=>{const previous=limit;limit+=12;renderGrid(true);const next=grid.children[previous];if(next)next.focus({preventScroll:true});});
    window.addEventListener('hashchange',()=>{if(root.isConnected)route(true);});
    const refreshLibraryPreview = () => {
      if (!root.isConnected) return;
      const selectedBrand = current?.slug;
      hydrateLibraries();
      productMediaRequests.clear();
      current = data.find(item => item.slug === selectedBrand) || null;
      renderGrid();
      if (current) loadProductMedia(current);
      if (inEditor) restoreEditorSelection();
    };
    const revealEditorBlock = blockId => {
      const record = libraryBlocks.get(blockId) || [...libraryBlocks.values()].find(item => {
        const editorAttributes = item.template?.getAttribute('data-shopify-editor-block');
        let editorData = {};
        try { editorData = JSON.parse(editorAttributes || '{}'); } catch (_) {}
        return editorData.id === blockId || editorData.domId === blockId;
      });
      if (!record) return;
      blockId = record.model.libraryBlock;
      selectedEditorBlock = blockId;
      saveEditorSelection({ blockId, brand: record.brand.slug });
      const url = new URL(location.href);
      url.hash = record.brand.slug;
      history.replaceState(history.state, '', url);
      route(false);
      const visible = record.brand.models.filter(model => model.enabled || model.libraryBlock === blockId);
      limit = Math.max(6, visible.findIndex(model => model.libraryBlock === blockId) + 1);
      renderGrid();
      const card = [...grid.querySelectorAll('[data-model-editor-block]')].find(item => item.dataset.modelEditorBlock === blockId);
      card?.scrollIntoView({ behavior: 'instant', block: 'center' });
    };
    const restoreEditorSelection = () => {
      const saved = readEditorSelection();
      if (!saved) return;
      if (saved.blockId && libraryBlocks.has(saved.blockId)) {
        revealEditorBlock(saved.blockId);
        return;
      }
      const brand = data.find(item => item.slug === saved.brand);
      if (!brand) return;
      selectedEditorBlock = '';
      saveEditorSelection({ brand: brand.slug });
      const url = new URL(location.href);
      url.hash = brand.slug;
      history.replaceState(history.state, '', url);
      route(false);
    };
    if (inEditor) {
      document.addEventListener('shopify:block:select', event => { if (root.isConnected) revealEditorBlock(event.detail.blockId); });
      document.addEventListener('shopify:block:deselect', () => { if (root.isConnected) { selectedEditorBlock = ''; renderGrid(); } });
      document.addEventListener('shopify:section:select', event => {
        if (!root.isConnected) return;
        const library = [...document.querySelectorAll('[data-gml-model-library]')].find(item => item.dataset.librarySection === event.detail.sectionId || item.dataset.librarySection.endsWith('__' + event.detail.sectionId));
        if (!library) return;
        saveEditorSelection({ brand: library.dataset.gmlModelLibrary });
        const url = new URL(location.href);
        url.hash = library.dataset.gmlModelLibrary;
        history.replaceState(history.state, '', url);
        route(false);
        root.scrollIntoView({ behavior: 'instant', block: 'start' });
      });
      ['shopify:section:load', 'shopify:section:reorder', 'shopify:section:unload'].forEach(name => document.addEventListener(name, () => requestAnimationFrame(refreshLibraryPreview)));
    }
    route(false);
    if (inEditor) restoreEditorSelection();
  }
  document.querySelectorAll('[data-gml-explore]').forEach(mount);
  document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-gml-explore]').forEach(mount));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gml-header"]) return;
  try {
    
  (() => {
    const initialize = () => {
      document.querySelectorAll('[data-gml-navigation]').forEach((root) => {
        if (root.dataset.gmlBound) return;
        root.dataset.gmlBound = 'true';
        const controller = new AbortController();
        const options = { signal: controller.signal };
        const bar = root.querySelector('[data-gml-topbar]');
        const dialogs = Array.from(root.querySelectorAll('[data-gml-dialog]'));
        let activeDialog = null;
        let returnFocus = null;
        let lockedScroll = 0;
        let previousStyles = null;
        let previousY = Math.max(0, window.scrollY);
        let referenceY = previousY;
        let frame = null;
        const showHeader = () => bar.removeAttribute('data-hidden');
        const updateHeader = () => {
          frame = null;
          if (activeDialog) return;
          const y = Math.max(0, window.scrollY);
          bar.toggleAttribute('data-scrolled', y > 16);
          const delta = y - referenceY;
          if (y < 120 || bar.contains(document.activeElement)) {
            showHeader();
            referenceY = y;
          } else if (Math.abs(delta) >= 8) {
            bar.toggleAttribute('data-hidden', delta > 0);
            referenceY = y;
          }
          previousY = y;
        };
        const lockScroll = () => {
          if (previousStyles) return;
          lockedScroll = window.scrollY;
          previousStyles = {};
          ['position', 'top', 'left', 'right', 'width', 'overflow'].forEach((key) => {
            previousStyles[key] = document.body.style[key];
          });
          Object.assign(document.body.style, {
            position: 'fixed', top: `-${lockedScroll}px`, left: '0', right: '0', width: '100%', overflow: 'hidden'
          });
        };
        const unlockScroll = () => {
          if (!previousStyles) return;
          Object.assign(document.body.style, previousStyles);
          previousStyles = null;
          const behavior = document.documentElement.style.scrollBehavior;
          document.documentElement.style.scrollBehavior = 'auto';
          window.scrollTo({ top: lockedScroll, left: 0, behavior: 'instant' });
          document.documentElement.style.scrollBehavior = behavior;
          previousY = Math.max(0, lockedScroll);
          referenceY = previousY;
        };
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        const mobileMenu = window.matchMedia('(max-width: 749px)');
        const menuPreviews = Array.from(root.querySelectorAll('[data-gml-menu-preview]'));
        const menuCategories = Array.from(root.querySelectorAll('[data-gml-menu-category]'));
        const menuDialog = root.querySelector('[data-gml-dialog="menu"]');
        const menuFeatures = root.querySelector('[data-gml-menu-features]');
        const rtl = getComputedStyle(root).direction === 'rtl';
        const firstPanelControl = (panel) => Array.from(panel?.querySelectorAll('a, button:not([disabled]), input:not([type="hidden"])') || []).find((control) => mobileMenu.matches || !control.classList.contains('gml-mobile-menu-back'));
        const menuDrawer = root.querySelector('[data-gml-menu-drawer]');
        const menuNavigation = root.querySelector('.gml-menu-navigation');
        let currentPreview = null;
        let previewRevision = 0;
        let previewAnimations = [];
        let menuClosePromise = null;
        let menuCloseRevision = 0;
        let menuNavigationPending = false;
        let previewBackPromise = null;
        const cancelPreviewAnimations = () => {
          previewAnimations.forEach((animation) => animation.cancel());
          previewAnimations = [];
        };
        const resetMenuPreview = () => {
          previewRevision += 1;
          cancelPreviewAnimations();
          currentPreview = null;
          menuNavigation.inert = false;
          menuDialog.classList.remove('has-preview', 'is-preview-closing');
          menuFeatures.hidden = true;
          menuFeatures.inert = false;
          menuPreviews.forEach((panel) => { panel.hidden = true; panel.inert = true; });
          menuCategories.forEach((button) => button.setAttribute('aria-expanded', 'false'));
        };
        const showMenuPreview = (group) => {
          const target = menuPreviews.find((panel) => panel.dataset.gmlMenuPreview === group);
          if (!target || menuClosePromise || menuNavigationPending || previewBackPromise) return;
          if (currentPreview === group) return target;
          const previous = menuPreviews.find((panel) => panel.dataset.gmlMenuPreview === currentPreview);
          const firstOpen = currentPreview === null;
          const revision = ++previewRevision;
          cancelPreviewAnimations();
          menuFeatures.hidden = false;
          menuFeatures.inert = false;
          menuPreviews.forEach((panel) => {
            panel.hidden = panel !== target && panel !== previous;
            panel.inert = panel !== target;
          });
          target.hidden = false;
          target.inert = false;
          menuCategories.forEach((button) => button.setAttribute('aria-expanded', String(button.dataset.gmlMenuCategory === group)));
          if (firstOpen) void menuDrawer.offsetWidth;
          menuDialog.classList.add('has-preview');
          if (mobileMenu.matches) {
            menuNavigation.inert = true;
            menuFeatures.scrollTop = 0;
          }
          if (!reducedMotion.matches && target.animate) {
            if (previous) {
              const outgoing = previous.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 180, easing: 'ease-out', fill: 'forwards' });
              previewAnimations.push(outgoing);
              outgoing.finished.then(() => {
                if (previewRevision === revision && previous !== target) previous.hidden = true;
              }).catch(() => {});
            }
            previewAnimations.push(target.animate([{ opacity: 0 }, { opacity: 1 }], { duration: firstOpen ? 400 : 300, easing: 'cubic-bezier(.22,1,.36,1)' }));
            target.querySelectorAll('.gml-menu-tile, .gml-menu-language').forEach((item, index) => {
              previewAnimations.push(item.animate([
                { opacity: 0, transform: mobileMenu.matches ? 'translateY(12px)' : 'translateX(-14px)' },
                { opacity: 1, transform: 'translateX(0)' }
              ], { duration: 400, delay: index * 60, easing: 'cubic-bezier(.22,1,.36,1)', fill: 'backwards' }));
            });
          } else if (previous) previous.hidden = true;
          currentPreview = group;
          return target;
        };
        menuCategories.forEach((button) => {
          button.addEventListener('click', (event) => {
            const panel = showMenuPreview(button.dataset.gmlMenuCategory);
            if (event.detail === 0) firstPanelControl(panel)?.focus({ preventScroll: true });
            if (!mobileMenu.matches && window.matchMedia('(max-width: 767px)').matches) panel?.scrollIntoView({ behavior: reducedMotion.matches ? 'instant' : 'smooth', block: 'nearest' });
          }, options);
          button.addEventListener('keydown', (event) => {
            if (event.key !== (rtl ? 'ArrowLeft' : 'ArrowRight')) return;
            event.preventDefault();
            firstPanelControl(showMenuPreview(button.dataset.gmlMenuCategory))?.focus();
          }, options);
        });
        menuPreviews.forEach((panel) => panel.addEventListener('keydown', (event) => {
          if (event.key !== (rtl ? 'ArrowRight' : 'ArrowLeft')) return;
          event.preventDefault();
          menuCategories.find((button) => button.dataset.gmlMenuCategory === currentPreview && (mobileMenu.matches || !button.closest('.gml-mobile-menu-toolbar')))?.focus();
        }, options));
        root.querySelectorAll('.gml-menu-language-form').forEach((form) => {
          let submitting = false;
          form.addEventListener('submit', (event) => {
            const returnTo = form.querySelector('input[name="return_to"]');
            if (returnTo) returnTo.value = window.location.pathname + window.location.search + window.location.hash;
            if (submitting) return;
            event.preventDefault();
            if (menuNavigationPending) return;
            menuNavigationPending = true;
            const submitter = event.submitter;
            const commit = () => {
              submitting = true;
              menuNavigationPending = false;
              if (submitter) form.requestSubmit(submitter);
              else form.requestSubmit();
            };
            if (window.GmlPageTransitions) window.GmlPageTransitions.navigate(window.location.href, { menu: true, beforeLeave: root.gmlCloseForNavigation, commit });
            else root.gmlCloseForNavigation().then(commit);
          }, options);
        });
        document.addEventListener('shopify:block:select', (event) => {
          const block = event.target.closest('[data-gml-preview-block]') || event.target.querySelector('[data-gml-preview-block]');
          if (!block || !root.contains(block)) return;
          openDialog('menu', root.querySelector('[data-gml-open="menu"]'));
          showMenuPreview(block.dataset.gmlPreviewBlock);
          block.scrollIntoView({ block: 'nearest' });
        }, options);

        let closeTimer = null;
        let openFrame = null;
        const waitForMotion = (element, property, duration) => {
          if (reducedMotion.matches) return Promise.resolve();
          return new Promise((resolve) => {
            let timer;
            const finish = () => {
              clearTimeout(timer);
              element.removeEventListener('transitionend', onEnd);
              resolve();
            };
            const onEnd = (event) => {
              if (event.target === element && event.propertyName === property) finish();
            };
            element.addEventListener('transitionend', onEnd);
            timer = setTimeout(finish, duration + 40);
          });
        };
        const closeMenu = () => {
          if (menuClosePromise) return menuClosePromise;
          if (!menuDialog.open) return Promise.resolve();
          const revision = ++menuCloseRevision;
          if (openFrame !== null) cancelAnimationFrame(openFrame);
          openFrame = null;
          menuDialog.classList.add('is-menu-closing');
          menuFeatures.inert = true;
          previewRevision += 1;
          cancelPreviewAnimations();
          menuClosePromise = (async () => {
            if (previewBackPromise) await previewBackPromise;
            if (menuDialog.classList.contains('has-preview')) {
              menuDialog.classList.add('is-preview-closing');
              menuDialog.classList.remove('has-preview');
              await waitForMotion(menuFeatures, 'clip-path', 450);
              if (revision !== menuCloseRevision) return;
              resetMenuPreview();
            }
            menuDialog.classList.add('is-closing');
            menuDialog.classList.remove('is-visible');
            await waitForMotion(menuDrawer, 'transform', 400);
            if (revision !== menuCloseRevision || !menuDialog.open) return;
            await new Promise((resolve) => {
              menuDialog.addEventListener('close', resolve, { once: true });
              menuDialog.close();
            });
          })().finally(() => {
            if (revision !== menuCloseRevision) return;
            menuClosePromise = null;
            menuDialog.classList.remove('is-menu-closing', 'is-preview-closing');
          });
          return menuClosePromise;
        };
        root.gmlHasOpenMenu = () => menuDialog.open;
        root.gmlCloseForNavigation = closeMenu;
        root.gmlCloseMobileMenuPreview = () => {
          if (!mobileMenu.matches || !currentPreview || menuClosePromise || menuNavigationPending) return Promise.resolve();
          if (previewBackPromise) return previewBackPromise;
          const group = currentPreview;
          const revision = ++previewRevision;
          cancelPreviewAnimations();
          menuFeatures.inert = true;
          menuDialog.classList.add('is-preview-closing');
          menuDialog.classList.remove('has-preview');
          previewBackPromise = waitForMotion(menuFeatures, 'clip-path', 450).then(() => {
            if (revision !== previewRevision) return;
            resetMenuPreview();
            menuCategories.find((button) => button.dataset.gmlMenuCategory === group && !button.closest('.gml-mobile-menu-toolbar'))?.focus({ preventScroll: true });
          }).finally(() => { previewBackPromise = null; });
          return previewBackPromise;
        };
        mobileMenu.addEventListener('change', () => {
          menuNavigation.inert = mobileMenu.matches && Boolean(currentPreview);
          menuFeatures.scrollTop = 0;
        }, options);
        const closeActive = (immediate = false) => {
          const dialog = activeDialog;
          if (!dialog?.open) return;
          if (!immediate && dialog === menuDialog) return closeMenu();
          if (openFrame !== null) cancelAnimationFrame(openFrame);
          openFrame = null;
          clearTimeout(closeTimer);
          dialog.classList.remove('is-visible');
          if (immediate || reducedMotion.matches) {
            if (dialog === menuDialog) {
              menuCloseRevision += 1;
              menuClosePromise = null;
              menuDialog.classList.remove('is-menu-closing', 'is-preview-closing');
            }
            dialog.close();
            return;
          }
          dialog.classList.add('is-closing');
          closeTimer = setTimeout(() => {
            if (dialog.open) dialog.close();
          }, 240);
        };
        const authenticated = root.dataset.gmlAuthenticated === 'true';
        const designMode = root.dataset.gmlDesignMode === 'true';
        const protectedDestination = (href) => {
          try {
            const url = new URL(href, window.location.href);
            if (url.origin !== window.location.origin || !/\/pages\/wishlist\/?$/.test(url.pathname)) return null;
            return url.pathname + url.search + url.hash;
          } catch { return null; }
        };
        const prepareSignIn = (dialog, destination) => {
          dialog.classList.toggle('gml-nav-dialog--gate', Boolean(destination));
          dialog.querySelectorAll('[data-gml-email-sign-in] input[name="return_to"]').forEach((input) => {
            input.value = destination || (window.location.pathname + window.location.search + window.location.hash);
          });
          dialog.querySelectorAll('[data-gml-sign-in]').forEach((link) => {
            if (!link.dataset.gmlDefaultHref) link.dataset.gmlDefaultHref = link.getAttribute('href');
            if (!destination) {
              link.setAttribute('href', link.dataset.gmlDefaultHref);
              return;
            }
            const login = new URL('/customer_authentication/login', window.location.origin);
            login.searchParams.set('return_to', destination);
            login.searchParams.set('locale', document.documentElement.lang || 'en');
            if (link.dataset.gmlSignIn === 'google') login.searchParams.set('acr_values', 'provider:google');
            link.setAttribute('href', login.pathname + login.search);
          });
        };
        const openDialog = (kind, trigger, destination = null) => {
          const dialog = dialogs.find((item) => item.dataset.gmlDialog === kind);
          if (!dialog || (kind === 'menu' && (menuClosePromise || menuNavigationPending))) return;
          if (kind === 'account') prepareSignIn(dialog, destination);
          if (kind === 'menu' && !dialog.open) resetMenuPreview();
          if (dialog.open && activeDialog === dialog) {
            clearTimeout(closeTimer);
            dialog.classList.remove('is-closing');
            dialog.classList.add('is-visible');
            return;
          }
          closeActive(true);
          returnFocus = trigger?.closest('dialog') ? root.querySelector('[data-gml-open="account"]') : trigger;
          activeDialog = dialog;
          showHeader();
          lockScroll();
          dialog.classList.remove('is-closing');
          dialog.showModal();
          if (trigger?.matches('[data-gml-open]')) trigger.setAttribute('aria-expanded', 'true');
          openFrame = requestAnimationFrame(() => {
            openFrame = requestAnimationFrame(() => {
              if (dialog.open && !dialog.classList.contains('is-closing')) dialog.classList.add('is-visible');
              openFrame = null;
            });
          });
          const target = dialog.querySelector('[data-gml-call-cancel]') || dialog.querySelector('[data-gml-search-input]') || dialog.querySelector('[data-gml-sign-in]') || dialog.querySelector('[data-gml-close]');
          target?.focus({ preventScroll: true });
        };
        root.querySelectorAll('[data-gml-open]').forEach((trigger) => {
          trigger.setAttribute('aria-expanded', 'false');
          trigger.addEventListener('click', () => openDialog(trigger.dataset.gmlOpen, trigger), options);
        });
        const resetSignOut = (scope) => scope.querySelectorAll('[data-gml-sign-out]').forEach((link) => {
          link.removeAttribute('data-confirming');
          const label = link.querySelector('[data-gml-sign-out-label]');
          const confirmation = link.querySelector('[data-gml-sign-out-confirm]');
          if (label) label.hidden = false;
          if (confirmation) confirmation.hidden = true;
        });
        document.addEventListener('click', (event) => {
          const link = event.target.closest('[data-gml-sign-out]');
          if (!link) return;
          if (link.hasAttribute('data-confirming')) {
            if (event.detail > 1) event.preventDefault();
            return;
          }
          event.preventDefault();
          link.setAttribute('data-confirming', '');
          link.querySelector('[data-gml-sign-out-label]').hidden = true;
          link.querySelector('[data-gml-sign-out-confirm]').hidden = false;
        }, { capture: true, signal: controller.signal });
        const openRequiredPage = () => {
          if (authenticated || designMode) return;
          const gate = document.querySelector('[data-gml-requires-sign-in]');
          if (!gate) return;
          const destination = protectedDestination(gate.dataset.gmlReturnTo);
          if (destination) openDialog('account', root.querySelector('[data-gml-open="account"]'), destination);
        };
        if (!authenticated && !designMode) {
          document.addEventListener('click', (event) => {
            if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
            const link = event.target.closest('a[href]');
            if (!link || link.hasAttribute('download') || (link.target && link.target !== '_self')) return;
            const destination = protectedDestination(link.href);
            if (!destination) return;
            event.preventDefault();
            event.stopPropagation();
            if (menuDialog.open) {
              if (menuNavigationPending) return;
              menuNavigationPending = true;
              closeMenu().then(() => {
                menuNavigationPending = false;
                openDialog('account', link, destination);
              });
            } else openDialog('account', link, destination);
          }, { capture: true, signal: controller.signal });
        }
        const menuDestination = (link) => {
          if (!link || link.hasAttribute('download') || (link.target && link.target !== '_self')) return null;
          try {
            const url = new URL(link.href, window.location.href);
            if (!/^https?:$/.test(url.protocol)) return null;
            return url;
          } catch { return null; }
        };
        const prepareMenuLink = (event) => {
          if (menuNavigationPending) return;
          const url = menuDestination(event.target.closest('a[href]'));
          if (url && url.origin === window.location.origin) window.GmlPageTransitions?.prepare(url.href);
        };
        menuDialog.addEventListener('pointerover', prepareMenuLink, options);
        menuDialog.addEventListener('focusin', prepareMenuLink, options);
        menuDialog.addEventListener('click', (event) => {
          if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          const url = menuDestination(event.target.closest('a[href]'));
          if (!url) return;
          event.preventDefault();
          event.stopPropagation();
          if (menuNavigationPending) return;
          menuNavigationPending = true;
          if (window.GmlPageTransitions && url.origin === window.location.origin) {
            window.GmlPageTransitions.prepare(url.href);
            Promise.resolve(window.GmlPageTransitions.navigate(url.href, { menu: true, beforeLeave: root.gmlCloseForNavigation }))
              .then(() => {
                if (url.pathname === window.location.pathname && url.search === window.location.search) menuNavigationPending = false;
              }).catch(() => { menuNavigationPending = false; });
          } else closeMenu().then(() => { window.location.assign(url.href); });
        }, options);
        dialogs.forEach((dialog) => {
          dialog.querySelectorAll('[data-gml-close]').forEach((button) => button.addEventListener('click', () => closeActive(), options));
          dialog.addEventListener('cancel', (event) => {
            event.preventDefault();
            if (dialog === menuDialog && mobileMenu.matches && currentPreview) {
              root.gmlCloseMobileMenuPreview();
              return;
            }
            closeActive();
          }, options);
          dialog.addEventListener('close', () => {
            resetSignOut(dialog);
            dialog.classList.remove('is-visible', 'is-closing');
            if (dialog === menuDialog) resetMenuPreview();
            root.querySelectorAll('[data-gml-open]').forEach((trigger) => {
              if (trigger.dataset.gmlOpen === dialog.dataset.gmlDialog) trigger.setAttribute('aria-expanded', 'false');
            });
            if (activeDialog !== dialog) return;
            clearTimeout(closeTimer);
            activeDialog = null;
            unlockScroll();
            showHeader();
            if (returnFocus?.isConnected) returnFocus.focus({ preventScroll: true });
            returnFocus = null;
          }, options);
          dialog.addEventListener('click', (event) => {
            if (event.target === dialog) closeActive();
            if (dialog !== menuDialog && !event.defaultPrevented && event.target.closest('a[href]') && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey) closeActive(true);
          }, options);
        });
        bar.addEventListener('focusin', showHeader, options);
        window.addEventListener('scroll', () => {
          if (frame === null) frame = requestAnimationFrame(updateHeader);
        }, { passive: true, signal: controller.signal });
        window.addEventListener('pageshow', (event) => {
          if (event.persisted && protectedDestination(window.location.href)) { window.location.reload(); return; }
          closeActive(true);
          menuNavigationPending = false;
          unlockScroll();
          referenceY = Math.max(0, window.scrollY);
          updateHeader();
          showHeader();
          requestAnimationFrame(openRequiredPage);
        }, options);
        document.addEventListener('shopify:section:unload', (event) => {
          if (!event.target.contains(root)) return;
          closeActive(true);
          unlockScroll();
          if (frame !== null) cancelAnimationFrame(frame);
          if (openFrame !== null) cancelAnimationFrame(openFrame);
          clearTimeout(closeTimer);
          controller.abort();
        }, options);
        updateHeader();
        if (document.readyState === 'complete') openRequiredPage();
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
    else initialize();
    document.addEventListener('shopify:section:load', initialize);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gml-home"] && !Shopify.designMode) return;
  try {
    
(() => {
  const mounted = new Map();
  const selections = new Map();
  const videoStateKey = 'gml-home-video:v2';
  const stateTime = state => Number.isFinite(state?.updatedAt) ? state.updatedAt : 0;
  const readVideoState = key => {
    const states = [];
    for (const storage of ['localStorage', 'sessionStorage']) {
      try {
        const state = JSON.parse(window[storage].getItem(key) || 'null');
        if (state && state.id != null) states.push(state);
      } catch (_) {}
    }
    const remembered = selections.get(key);
    if (remembered) states.push(remembered);
    return states.sort((a, b) => stateTime(b) - stateTime(a))[0] || null;
  };
  const writeVideoState = (key, state) => {
    state.updatedAt = Math.max(Date.now(), stateTime(readVideoState(key)) + 1);
    selections.set(key, state);
    for (const storage of ['localStorage', 'sessionStorage']) {
      try { window[storage].setItem(key, JSON.stringify(state)); } catch (_) {}
    }
  };
  const selectVideo = (candidates, previous, random = Math.random) => {
    if (!candidates.length) return null;
    const alternatives = candidates.filter(candidate => String(candidate.id) !== String(previous?.id));
    const pool = candidates.length > 1 && alternatives.length ? alternatives : candidates;
    const candidate = pool[Math.floor(random() * pool.length)];
    let fraction = 0;
    if (candidates.length === 1 && String(previous?.id) === String(candidate.id)) {
      const previousFraction = Math.max(0, Math.min(.8, Number(previous.fraction) || 0));
      const previousPosition = Number.isFinite(previous.position) ? previous.position : previousFraction;
      const starts = [.08, .24, .4, .56, .72].filter(start => Math.abs(start - previousPosition) > .12 && Math.abs(start - previousFraction) > .12);
      if (starts.length) fraction = starts[Math.floor(random() * starts.length)];
    }
    return { id: String(candidate.id), fraction };
  };
  const rankVideoSources = (sources, video) => {
    const resolution = source => Math.max(0, Number(source.width) || 0) * Math.max(0, Number(source.height) || 0);
    return (Array.isArray(sources) ? sources : []).filter(source =>
      typeof source?.url === 'string' && source.url.trim() &&
      typeof source.mime_type === 'string' && source.mime_type.trim() &&
      video.canPlayType(source.mime_type) !== ''
    ).sort((a, b) => {
      const qualityPriority = (Number(b.priority) || 0) - (Number(a.priority) || 0);
      const mp4Priority = Number(b.mime_type.split(';')[0].trim().toLowerCase() === 'video/mp4') - Number(a.mime_type.split(';')[0].trim().toLowerCase() === 'video/mp4');
      return resolution(b) - resolution(a) || qualityPriority || mp4Priority;
    });
  };
  const clamp = value => Math.max(0, Math.min(1, value));
  const initHome = (scope = document) => {
    const homes = [...scope.querySelectorAll('[data-gml-home]')];
    if (scope.matches?.('[data-gml-home]')) homes.unshift(scope);
    homes.forEach(home => {
      if (mounted.has(home)) return;
      const cinema = home.querySelector('[data-gml-home-cinema]');
      const media = home.querySelector('.gml-home__media');
      const hero = home.querySelector('.gml-home__hero');
      const discover = home.querySelector('.gml-home__discover');
      if (!cinema || !media || !hero || !discover) return;
      const video = home.querySelector('.gml-home__video');
      const cards = [...home.querySelectorAll('.gml-home__card')];
      const cardTrack = home.querySelector('[data-gml-home-cards]');
      const cardPages = [...home.querySelectorAll('[data-gml-home-card-page]')];
      const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const controller = new AbortController();
      const signal = controller.signal;
      const syncCardPage = () => {
        if (!cardTrack || !cards.length) return;
        const firstLeft = cards[0].offsetLeft;
        const activeIndex = cards.reduce((nearest, card, index) => {
          const distance = Math.abs(card.offsetLeft - firstLeft - cardTrack.scrollLeft);
          const nearestDistance = Math.abs(cards[nearest].offsetLeft - firstLeft - cardTrack.scrollLeft);
          return distance < nearestDistance ? index : nearest;
        }, 0);
        cardPages.forEach((page, index) => page.setAttribute('aria-pressed', String(index === activeIndex)));
      };
      cardTrack?.addEventListener('scroll', syncCardPage, { passive: true, signal });
      cardPages.forEach(page => page.addEventListener('click', () => {
        const card = cards[Number(page.dataset.gmlHomeCardPage)];
        if (!cardTrack || !card || !window.matchMedia('(max-width: 749px)').matches) return;
        cardTrack.scrollTo({ left: card.offsetLeft - cards[0].offsetLeft, behavior: motion.matches ? 'instant' : 'smooth' });
      }, { signal }));
      let videoState = null;
      let selectedVideo = null;
      let sourceReady = !video;
      let sourceController = null;
      let sourceRevision = 0;
      let candidates = [];
      if (video) {
        try { candidates = JSON.parse(home.querySelector('[data-gml-home-video-sources]')?.textContent || '[]'); } catch (_) {}
        candidates = (Array.isArray(candidates) ? candidates : []).filter(candidate => candidate && candidate.id != null).map(candidate => ({
          ...candidate,
          sources: rankVideoSources(candidate.sources, video)
        })).filter((candidate, index, all) => candidate.sources.length && all.findIndex(item => item.sources.length && String(item.id) === String(candidate.id)) === index).slice(0, 5);
      }
      let frame = 0;
      let playRequest = null;
      let playbackRevision = 0;
      let playBlocked = false;
      let shouldPlay = false;
      let lastPlayback = null;
      let disposed = false;
      const syncPlayback = () => {
        if (!video || disposed) return;
        if (!shouldPlay) {
          if (!video.paused) video.pause();
        } else if (sourceReady && video.paused && !playRequest && !playBlocked) {
          const request = { revision: playbackRevision };
          playRequest = request;
          video.play().then(() => {
            if (disposed || !shouldPlay) video.pause();
          }).catch(() => {
            if (request === playRequest && request.revision === playbackRevision) playBlocked = true;
          }).finally(() => {
            if (request === playRequest) playRequest = null;
            if (!disposed && shouldPlay && request.revision !== playbackRevision) syncPlayback();
          });
        }
      };
      const loadVideoSource = (candidate, state, sourceIndex = 0) => {
        if (!video || disposed) return;
        sourceController?.abort();
        sourceController = new AbortController();
        const sourceSignal = sourceController.signal;
        const revision = ++sourceRevision;
        playbackRevision += 1;
        sourceReady = false;
        playRequest = null;
        playBlocked = false;
        video.pause();
        const ready = () => {
          if (disposed || revision !== sourceRevision || sourceReady) return;
          sourceReady = true;
          syncPlayback();
        };
        video.addEventListener('loadedmetadata', () => {
          if (disposed || revision !== sourceRevision) return;
          const duration = video.duration;
          const startTime = Number.isFinite(duration) && duration > 0 ? Math.min(state.fraction * duration, Math.max(0, duration - .25)) : 0;
          if (startTime > .01) {
            video.addEventListener('seeked', ready, { once: true, signal: sourceSignal });
            try { video.currentTime = startTime; } catch (_) { ready(); }
          } else ready();
        }, { once: true, signal: sourceSignal });
        video.addEventListener('error', () => {
          if (disposed || revision !== sourceRevision || ![2, 3, 4].includes(video.error?.code)) return;
          if (sourceIndex + 1 < candidate.sources.length) loadVideoSource(candidate, state, sourceIndex + 1);
        }, { signal: sourceSignal });
        video.removeAttribute('src');
        video.replaceChildren();
        video.src = candidate.sources[sourceIndex].url;
        video.preload = 'metadata';
        video.load();
      };
      const chooseVideo = (freshVisit = false) => {
        if (!video || !candidates.length || disposed) return;
        const remembered = selections.get(videoStateKey);
        videoState = !freshVisit && remembered && candidates.some(candidate => String(candidate.id) === remembered.id)
          ? remembered
          : selectVideo(candidates, readVideoState(videoStateKey));
        selectedVideo = candidates.find(candidate => String(candidate.id) === videoState.id);
        writeVideoState(videoStateKey, videoState);
        home.classList.toggle('gml-home--crop-bars', Boolean(selectedVideo.crop));
        video.style.aspectRatio = selectedVideo.aspect > 0 ? String(selectedVideo.aspect) : '';
        video.poster = selectedVideo.poster || video.poster;
        loadVideoSource(selectedVideo, videoState);
      };
      const update = () => {
        frame = 0;
        if (disposed) return;
        const rect = cinema.getBoundingClientRect();
        const height = Math.max(1, hero.offsetHeight);
        const distance = Math.max(0, -rect.top);
        const progress = clamp(distance / (height * .7));
        media.style.setProperty('--gml-backdrop-shade', String(.24 + .32 * progress));
        cards.forEach((card, index) => {
          const reveal = motion.matches ? 1 : clamp((distance / height - .12 - index * .035) / .57);
          card.style.setProperty('--gml-card-opacity', String(.15 + .85 * reveal));
          card.style.setProperty('--gml-card-offset', ((1 - reveal) * 56).toFixed(2) + 'px');
        });
        shouldPlay = !document.hidden && !motion.matches;
        if (lastPlayback !== shouldPlay) {
          lastPlayback = shouldPlay;
          playbackRevision += 1;
          if (shouldPlay) playBlocked = false;
        }
        syncPlayback();
      };
      const schedule = () => { if (!disposed && !frame) frame = requestAnimationFrame(update); };
      const preferenceChanged = schedule;
      window.addEventListener('scroll', schedule, { passive: true, signal });
      window.addEventListener('resize', schedule, { passive: true, signal });
      const refreshPlayback = () => { cancelAnimationFrame(frame); update(); };
      window.addEventListener('pageshow', event => {
        if (event.persisted) chooseVideo(true);
        refreshPlayback();
      }, { signal });
      document.addEventListener('visibilitychange', refreshPlayback, { signal });
      motion.addEventListener('change', preferenceChanged);
      const resize = new ResizeObserver(schedule);
      resize.observe(cinema);
      home.querySelectorAll('[data-gml-home-scroll]').forEach(link => {
        link.addEventListener('click', event => {
          const target = document.getElementById(link.hash.slice(1));
          if (!target || !home.contains(target)) return;
          event.preventDefault();
          const top = target.getBoundingClientRect().top + window.scrollY;
          target.focus({ preventScroll: true });
          window.scrollTo({ top, behavior: motion.matches ? 'instant' : 'smooth' });
        }, { signal });
      });
      const rememberVideo = () => {
        if (!videoState || !video) return;
        if (Number.isFinite(video.duration) && video.duration > 0) {
          videoState.position = video.currentTime / video.duration;
        }
        if (String(readVideoState(videoStateKey)?.id) === videoState.id) writeVideoState(videoStateKey, videoState);
      };
      window.addEventListener('pagehide', rememberVideo, { signal });
      if (video) {
        video.muted = true;
        video.playsInline = true;
        video.loop = true;
        const retryPlayback = () => {
          if (!shouldPlay || !video.paused) return;
          playBlocked = false;
          playbackRevision += 1;
          syncPlayback();
        };
        document.addEventListener('pointerdown', retryPlayback, { capture: true, passive: true, signal });
        document.addEventListener('keydown', retryPlayback, { capture: true, signal });
        chooseVideo();
      }
      const cleanup = () => {
        rememberVideo();
        disposed = true;
        sourceRevision += 1;
        playbackRevision += 1;
        sourceController?.abort();
        controller.abort();
        resize.disconnect();
        motion.removeEventListener('change', preferenceChanged);
        cancelAnimationFrame(frame);
        video?.pause();
        mounted.delete(home);
        delete home.dataset.ready;
        if (!mounted.size) document.documentElement.classList.remove('gml-home-snap');
      };
      mounted.set(home, cleanup);
      document.documentElement.classList.add('gml-home-snap');
      update();
      home.dataset.ready = 'true';
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initHome(), { once: true });
  else initHome();
  document.addEventListener('shopify:section:load', event => initHome(event.target));
  document.addEventListener('shopify:section:unload', event => {
    for (const [home, cleanup] of mounted) {
      if (event.target === home || event.target.contains(home)) cleanup();
    }
  });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gml-inventory"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialise = (root) => {
    if (root.dataset.inventoryReady) return;
    root.dataset.inventoryReady = 'true';
    const animate = (container) => {
      if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      container.querySelectorAll('.product-card').forEach((card, index) => {
        let wrapper = card.closest('.gml-inventory__item');
        if (!wrapper) {
          wrapper = document.createElement('div');
          wrapper.className = 'gml-inventory__item';
          card.before(wrapper);
          wrapper.append(card);
        }
        if (wrapper.dataset.entered) return;
        wrapper.dataset.entered = 'true';
        wrapper.animate([{ opacity: 0, transform: 'translateY(16px)' }, { opacity: 1, transform: 'translateY(0)' }], { duration: 570, delay: Math.min(index % 24, 7) * 42, easing: 'cubic-bezier(.2,.7,.2,1)', fill: 'backwards' });
      });
    };
    animate(root);
    const catalogueScript = root.querySelector('[data-gml-catalogue]');
    if (!catalogueScript) return;
    const catalogue = JSON.parse(catalogueScript.textContent);
    const strings = JSON.parse(root.querySelector('[data-inventory-price-strings]').textContent);
    const initialParams = new URLSearchParams(location.search);
    const brand = catalogue.find(item => item.slug === initialParams.get('gml_brand'));
    const model = brand && brand.models.find(item => item.slug === initialParams.get('gml_model'));
    const modelMode = Boolean(model);
    root.classList.toggle('gml-inventory--model', modelMode);
    const collectionMode = root.dataset.collectionMode === 'true';
    const isWatchScope = collectionMode || initialParams.get('gml_scope') === 'watches' || Boolean(brand);
    const exclusion = ' NOT product_type:"Accessories" NOT product_type:"Eyewear" NOT product_type:"Jewelry" NOT product_type:"Jewellery"';
    const vendorQuery = (item) => `vendor:"${item.name.toUpperCase().replace(/["\\]/g, '')}"`;
    const canonicalBrandQuery = brand ? vendorQuery(brand) : `(${catalogue.map(vendorQuery).join(' OR ')})`;
    const baseQuery = isWatchScope ? `(${model ? model.query : canonicalBrandQuery})${exclusion}` : '';
    const originalQuery = initialParams.get('q') || '';
    let freeText = initialParams.get('gml_text') || '';
    if (!freeText && !isWatchScope) freeText = originalQuery === '*' ? '' : originalQuery;
    const quoteText = (value) => (value.trim().match(/\S+/g) || []).map(word => `"${word.replace(/["\\]/g, '\\$&')}"`).join(' AND ');
    const scopedQuery = () => {
      if (modelMode) return baseQuery;
      const term = quoteText(freeText);
      return baseQuery ? `${baseQuery}${term ? ` AND (${term})` : ''}` : (term || '*');
    };
    const maxFrom = (value) => {
      if (value === null || value === undefined || value === '') return null;
      const text = String(value).trim();
      if (!/^(?:(?:\d+|\d{1,3}(?:,\d{3})+)(?:\.\d{1,2})?|\.\d{1,2})$/.test(text)) return null;
      const number = Number(text.replaceAll(',', ''));
      return Number.isFinite(number) && number >= 0 && Number.isSafeInteger(Math.round(number * 100)) ? number : null;
    };
    const currentCurrency = root.dataset.currency;
    const server = root.querySelector('[data-inventory-server]');
    const filtered = root.querySelector('[data-inventory-filtered]');
    const grid = root.querySelector('[data-price-grid]');
    const count = root.querySelector('[data-inventory-count]');
    const status = root.querySelector('[data-price-status]');
    const empty = root.querySelector('[data-price-empty]');
    const errorPanel = root.querySelector('[data-price-error]');
    const errorText = root.querySelector('[data-price-error-text]');
    const moreWrap = root.querySelector('[data-price-more-wrap]');
    const more = root.querySelector('[data-price-more]');
    const form = root.querySelector('.gml-inventory__search');
    const searchInput = form.querySelector('[name="q"]');
    const back = root.querySelector('[data-model-back]');
    let selectedMin = modelMode ? 0 : maxFrom(initialParams.get('gml_min')) || 0;
    let selectedMax = modelMode ? null : maxFrom(initialParams.get('gml_max'));
    let selectedSort = !modelMode && ['price-ascending', 'price-descending'].includes(initialParams.get('gml_sort')) ? initialParams.get('gml_sort') : 'featured';
    const facets = Object.fromEntries(['brand', 'material', 'dial'].map(key => [key, modelMode ? '' : initialParams.get('gml_' + key + '_filter') || '']));
    const sortControl = root.querySelector('[data-inventory-sort]');
    const facetControls = [...root.querySelectorAll('[data-inventory-facet]')];
    sortControl.value = selectedSort;
    let items = null;
    let pending = null;
    let generation = 0;
    let visibleLimit = 24;
    let matches = [];
    if (brand) {
      const brandTitle = initialParams.has('gml_brand_title') ? initialParams.get('gml_brand_title') : brand.name;
      const modelTitle = model ? (initialParams.has('gml_model_title') ? initialParams.get('gml_model_title') : model.name) : '';
      root.querySelector('[data-inventory-title]').textContent = brandTitle + (modelTitle ? (brandTitle ? ' — ' : '') + modelTitle : '');
      back.textContent = brand.name;
      back.hidden = false;
      root.querySelector('[data-brand-crumb-divider]').hidden = false;
      if (model) {
        root.querySelector('[data-model-crumb-divider]').hidden = false;
        const modelCrumb = root.querySelector('[data-current-model]');
        modelCrumb.textContent = model.name;
        modelCrumb.hidden = false;
      }
    }
    searchInput.value = freeText;
    if (modelMode) {
      root.querySelector('.gml-inventory__heading').append(form);
      root.querySelector('[data-gml-price]').hidden = true;
      root.querySelector('[data-inventory-filters]').hidden = true;
      searchInput.placeholder = root.dataset.modelSearchPlaceholder;
      form.querySelector('label').textContent = root.dataset.modelSearchPlaceholder;
      empty.querySelector('h2').textContent = root.dataset.modelEmptyTitle;
      empty.querySelector('p').textContent = root.dataset.modelEmptyText;
      root.querySelector('[data-price-clear]').textContent = root.dataset.modelClearLabel;
    }
    const refreshLinks = () => {
      const current = new URL(location.href);
      const backURL = new URL(back.getAttribute('href'), location.origin);
      ['preview_theme_id', 'preview_key', 'currency', 'country', 'locale', 'gml_min', 'gml_max'].forEach(key => {
        if (current.searchParams.has(key)) backURL.searchParams.set(key, current.searchParams.get(key));
        else backURL.searchParams.delete(key);
      });
      if (brand) backURL.hash = brand.slug;
      back.href = backURL.href;
      const backArrow = root.querySelector('[data-gml-back]');
      if (backArrow) { backArrow.href = backURL.href; backArrow.dataset.gmlBackFallback = backURL.href; }
    };
    const updateAddress = () => {
      const url = new URL(location.href);
      url.searchParams.delete('page');
      url.searchParams.delete('filter.v.price.lte');
      url.searchParams.delete('filter.v.price.gte');
      if (selectedMin > 0) url.searchParams.set('gml_min', String(selectedMin));
      else url.searchParams.delete('gml_min');
      if (selectedMax === null) url.searchParams.delete('gml_max');
      else url.searchParams.set('gml_max', String(selectedMax));
      if (selectedSort !== 'featured') url.searchParams.set('gml_sort', selectedSort); else url.searchParams.delete('gml_sort');
      Object.entries(facets).forEach(([key, value]) => { if (value) url.searchParams.set('gml_' + key + '_filter', value); else url.searchParams.delete('gml_' + key + '_filter'); });
      if (modelMode) {
        url.searchParams.set('q', baseQuery);
        url.searchParams.delete('sort_by');
        [...url.searchParams.keys()].forEach(key => { if (key.startsWith('filter.')) url.searchParams.delete(key); });
        if (freeText.trim()) url.searchParams.set('gml_text', freeText.trim());
        else url.searchParams.delete('gml_text');
      }
      history.replaceState(history.state, '', url);
      refreshLinks();
    };
    refreshLinks();
    const normalise = value => String(value || '').trim().replace(/\s+/g, ' ').toLocaleLowerCase();
    const modelSearchMatch = item => {
      if (!modelMode) return true;
      const terms = normalise(freeText).normalize('NFD').replace(/[\u0300-\u036f]/g, '').split(/\s+/).filter(Boolean);
      const searchable = normalise([item.dial, item.year, item.title].filter(Boolean).join(' ')).normalize('NFD').replace(/[\u0300-\u036f]/g, '');
      return terms.every(term => searchable.includes(term));
    };
    const materialGroups = value => {
      const text = window.GmlLocale?.watchTerms(value) || normalise(value).normalize('NFD').replace(/[\u0300-\u036f]/g, '');
      const groups = [];
      const plated = /\bgold[ -]plat(?:ed|ing)\b|\bgold[ -]filled\b/.test(text);
      if (/\b(?:stainless[ -]steel|oystersteel|steel)\b/.test(text)) groups.push('steel');
      if (plated) groups.push('gold_plated');
      else {
        if (/\byellow[ -]gold\b/.test(text)) groups.push('yellow_gold');
        if (/\bwhite[ -]gold\b/.test(text)) groups.push('white_gold');
        if (/\b(?:rose|pink|everose)[ -]gold\b|\beverose\b/.test(text)) groups.push('rose_gold');
        if (/\bgold\b/.test(text) && !groups.some(group => group.endsWith('_gold'))) groups.push('gold');
      }
      [['titanium', /\btitanium\b/], ['platinum', /\bplatinum\b/], ['ceramic', /\bceramic\b/], ['carbon', /\bcarbon\b/], ['bronze', /\bbronze\b/], ['tantalum', /\btantalum\b/], ['sapphire', /\bsapphire\b/], ['quartz_tpt', /\bquartz[ -]tpt\b/]].forEach(([key, pattern]) => { if (pattern.test(text)) groups.push(key); });
      return groups;
    };
    const dialGroups = value => {
      const text = window.GmlLocale?.watchTerms(value) || normalise(value).normalize('NFD').replace(/[\u0300-\u036f]/g, '');
      const base = text.split(/\b(?:with|featuring|set with|hands|hour markers|indices|numerals|luminescen\w*|luminous)\b|[.;]/)[0];
      const groups = [];
      const rules = [['mother_of_pearl', /\bmother[ -]of[ -]pearl\b|\bmop\b|\bnacre\b/], ['skeleton', /\bskeleton\w*\b|\bopen[ -]?work\w*\b/], ['blue', /\bblue\b|\bturquoise\b/], ['black', /\bblack\b|\bonyx\b/], ['green', /\bgreen\b|\bolive\b/], ['brown', /\bbrown\b|\bchocolat\w*\b/], ['white', /\bwhite\b/], ['champagne', /\bchampagne\b/], ['silver', /\bsilver(?:ed)?\b/], ['grey', /\bgr[ae]y\b|\bslate\b|\brhodium\b|\banthracite\b/], ['pink', /\bpink\b|\bsalmon\b/], ['purple', /\bpurple\b|\baubergine\b|\bviolet\b/], ['red', /\bred\b|\bburgundy\b/], ['yellow', /\byellow\b/], ['orange', /\borange\b/], ['gold', /\bgold(?:en)?\b/], ['sundust', /\bsundust\b/], ['meteorite', /\bmeteorite\b/]];
      rules.forEach(([key, pattern]) => { if (pattern.test(base)) groups.push(key); });
      return groups;
    };
    const facetValues = (item, key) => key === 'brand' ? [normalise(item.brand) || '__unspecified'] : (item[key + 'Groups'].length ? item[key + 'Groups'] : ['__unspecified']);
    const prepareItems = products => {
      const allItems = products.filter(item => !isWatchScope || item.isWatch === true);
      allItems.forEach(item => {
        item.brand = String(item.vendor || '').trim();
        item.materialGroups = materialGroups(item.material);
        item.dialGroups = dialGroups(item.dial);
      });
      facetControls.forEach(control => {
        const key = control.dataset.inventoryFacet;
        const options = new Map();
        allItems.forEach(item => facetValues(item, key).forEach(value => options.set(value, value === '__unspecified' ? strings.unspecified : key === 'brand' ? item.brand : strings.facetLabels[key][value])));
        control.replaceChildren(new Option(strings.any, ''));
        [...options].sort((a, b) => a[1].localeCompare(b[1])).forEach(([value, label]) => control.add(new Option(label, value)));
        if (facets[key] && !options.has(facets[key])) control.add(new Option(facets[key] === '__unspecified' ? strings.unspecified : facets[key], facets[key]));
        control.value = facets[key];
        control.disabled = options.size === 0;
      });
      return allItems;
    };
    const syncFilterSummary = () => {
      const activeCount = Object.values(facets).filter(Boolean).length + (selectedSort !== 'featured' ? 1 : 0);
      const badge = root.querySelector('[data-filter-count]');
      badge.hidden = activeCount === 0;
      badge.textContent = String(activeCount);
    };
    form.addEventListener('submit', event => {
      event.preventDefault();
      freeText = searchInput.value;
      if (modelMode) { applyRange(0, null); return; }
      const url = new URL(window.GmlLocale?.url(root.dataset.searchRoute) || root.dataset.searchRoute, location.origin);
      const current = new URLSearchParams(location.search);
      current.forEach((value, key) => {
        if (!['q', 'view', 'type', 'page', 'gml_text', 'filter.v.price.lte', 'filter.v.price.gte'].includes(key)) url.searchParams.append(key, value);
      });
      url.searchParams.set('type', 'product');
      url.searchParams.set('view', 'gml-results');
      if (isWatchScope) url.searchParams.set('gml_scope', 'watches');
      url.searchParams.set('q', scopedQuery());
      if (freeText.trim()) url.searchParams.set('gml_text', freeText.trim());
      if (selectedMin > 0) url.searchParams.set('gml_min', String(selectedMin));
      else url.searchParams.delete('gml_min');
      if (selectedMax === null) url.searchParams.delete('gml_max');
      else url.searchParams.set('gml_max', String(selectedMax));
      location.assign(window.GmlLocale?.url(url.href) || url.href);
    });
    const fail = (key) => Object.assign(new Error(key), { priceMessage: key });
    const fetchCompleteInventory = async () => {
      if (items) return items;
      if (pending) return pending;
      pending = (async () => {
        const firstURL = new URL(window.GmlLocale?.url(root.dataset.searchRoute) || root.dataset.searchRoute, location.origin);
        new URLSearchParams(location.search).forEach((value, key) => {
          if (modelMode && (key.startsWith('filter.') || key === 'sort_by')) return;
          if (!['page', 'q', 'view', 'type', 'gml_min', 'gml_max', 'filter.v.price.lte', 'filter.v.price.gte'].includes(key)) firstURL.searchParams.append(key, value);
        });
        firstURL.searchParams.set('q', modelMode ? baseQuery : originalQuery || baseQuery || '*');
        firstURL.searchParams.set('view', 'gml-price-data');
        firstURL.searchParams.set('type', 'product');
        firstURL.searchParams.set('page', '1');
        const collected = [];
        const ids = new Set();
        const visited = new Set();
        let nextURL = firstURL;
        let expectedPage = 1;
        let expectedTotal = null;
        let expectedPages = null;
        while (nextURL) {
          if (nextURL.origin !== location.origin || nextURL.pathname !== firstURL.pathname || visited.has(nextURL.href)) throw fail('error');
          visited.add(nextURL.href);
          const controller = new AbortController();
          const timeout = setTimeout(() => controller.abort(), 30000);
          let response;
          let payload;
          try {
            response = await fetch(nextURL.href, { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' }, signal: controller.signal });
            if (!response.ok) throw fail('error');
            payload = await response.json();
          } finally {
            clearTimeout(timeout);
          }
          if (payload.version !== 1 || !Array.isArray(payload.items) || !Number.isInteger(payload.total) || !Number.isInteger(payload.pages) || payload.currentPage !== expectedPage || payload.total < 0 || payload.pages < 0) throw fail('error');
          if (payload.currency !== currentCurrency) throw fail('currency_error');
          if (payload.total > 25000 || payload.pages > 100) throw fail('too_many');
          if (expectedTotal === null) { expectedTotal = payload.total; expectedPages = payload.pages; }
          if (payload.total !== expectedTotal || payload.pages !== expectedPages) throw fail('error');
          for (const item of payload.items) {
            if (typeof item.id !== 'string' || ids.has(item.id) || !Number.isFinite(item.priceCents) || typeof item.available !== 'boolean' || typeof item.inquireOnly !== 'boolean' || typeof item.html !== 'string') throw fail('error');
            ids.add(item.id);
            collected.push(item);
          }
          if (payload.nextURL) {
            if (expectedPage >= payload.pages) throw fail('error');
            nextURL = new URL(payload.nextURL, firstURL);
            nextURL = new URL(window.GmlLocale?.url(nextURL.href) || nextURL.href, firstURL);
            firstURL.searchParams.forEach((value, key) => { if (key !== 'page') nextURL.searchParams.set(key, value); });
            nextURL.searchParams.set('page', String(expectedPage + 1));
            expectedPage += 1;
          } else {
            if (expectedPage < payload.pages) throw fail('error');
            nextURL = null;
          }
        }
        if (collected.length !== expectedTotal) throw fail('error');
        items = prepareItems(collected);
        return items;
      })();
      try { return await pending; } finally { pending = null; }
    };
    const renderMatches = (previousLimit = 0) => {
      const shown = matches.slice(0, visibleLimit);
      grid.innerHTML = shown.map((item, index) => `<div class="gml-inventory__item"${index < previousLimit ? ' data-entered="true"' : ''}>${item.html}</div>`).join('');
      count.textContent = matches.length === 1 && root.dataset.singleResultLabel ? root.dataset.singleResultLabel : strings.count.replace('[count]', String(matches.length));
      empty.hidden = matches.length !== 0;
      root.querySelector('[data-price-clear]').hidden = modelMode && !freeText.trim();
      grid.hidden = matches.length === 0;
      moreWrap.hidden = visibleLimit >= matches.length;
      status.textContent = '';
      filtered.setAttribute('aria-busy', 'false');
      animate(grid);
      window.BLANO?.bootWishlistUI?.();
      root.dispatchEvent(new CustomEvent('gml:products-rendered', { bubbles: true }));
    };
    const applyRange = async (minPrice, maxPrice, updateURL = true) => {
      selectedMin = modelMode ? 0 : maxFrom(minPrice) || 0;
      selectedMax = modelMode ? null : maxFrom(maxPrice);
      if (updateURL) updateAddress();
      const requestGeneration = ++generation;
      visibleLimit = 24;
      errorPanel.hidden = true;
      empty.hidden = true;
      moreWrap.hidden = true;
      server.hidden = true;
      filtered.hidden = false;
      grid.hidden = true;
      grid.replaceChildren();
      status.textContent = strings.loading;
      count.textContent = '';
      filtered.setAttribute('aria-busy', 'true');
      try {
        const allItems = await fetchCompleteInventory();
        if (requestGeneration !== generation) return;
        const priceActive = selectedMin > 0 || selectedMax !== null;
        const hasPrice = item => item.available && !item.inquireOnly && item.priceCents > 0;
        matches = allItems.filter(item => modelSearchMatch(item) && (!priceActive || (hasPrice(item) && item.priceCents >= Math.round(selectedMin * 100) && (selectedMax === null || item.priceCents <= Math.round(selectedMax * 100)))) && Object.entries(facets).every(([key, value]) => !value || facetValues(item, key).includes(value)));
        if (selectedSort !== 'featured') matches.sort((a, b) => Number(hasPrice(b)) - Number(hasPrice(a)) || (hasPrice(a) && hasPrice(b) ? (a.priceCents - b.priceCents) * (selectedSort === 'price-descending' ? -1 : 1) : 0));
        syncFilterSummary();
        renderMatches();
      } catch (error) {
        if (requestGeneration !== generation) return;
        status.textContent = '';
        filtered.setAttribute('aria-busy', 'false');
        errorText.textContent = strings[error.priceMessage] || strings.error;
        errorPanel.hidden = false;
      }
    };
    root.addEventListener('gml:price-change', event => {
      if (modelMode) return;
      if (event.detail?.currency && event.detail.currency !== currentCurrency) return;
      applyRange(event.detail?.minPrice, event.detail?.maxPrice);
    });
    const resetSelection = () => {
      if (modelMode) { freeText = ''; searchInput.value = ''; }
      selectedSort = 'featured';
      sortControl.value = selectedSort;
      Object.keys(facets).forEach(key => { facets[key] = ''; });
      facetControls.forEach(control => { control.value = ''; });
      root.querySelector('[data-gml-price]')?.dispatchEvent(new CustomEvent('gml:price-sync', { detail: { minPrice: 0, maxPrice: null } }));
      applyRange(0, null);
    };
    sortControl.addEventListener('change', () => { selectedSort = sortControl.value; applyRange(selectedMin, selectedMax); });
    facetControls.forEach(control => control.addEventListener('change', () => { facets[control.dataset.inventoryFacet] = control.value; applyRange(selectedMin, selectedMax); }));
    root.querySelector('[data-inventory-reset]').addEventListener('click', resetSelection);
    const filtersPanel = root.querySelector('[data-inventory-filters]');
    filtersPanel.addEventListener('toggle', () => {
      if (filtersPanel.open && !matchMedia('(prefers-reduced-motion: reduce)').matches) filtersPanel.querySelector('.gml-inventory__filter-panel').animate([{ opacity: 0, transform: 'translateY(-8px)' }, { opacity: 1, transform: 'translateY(0)' }], { duration: 280, easing: 'ease-out' });
    });
    root.addEventListener('gml:price-reset', resetSelection);
    root.querySelector('[data-price-clear]').addEventListener('click', resetSelection);
    root.querySelector('[data-price-retry]').addEventListener('click', () => applyRange(selectedMin, selectedMax, false));
    more.addEventListener('click', () => {
      const previousLimit = visibleLimit;
      visibleLimit += 24;
      renderMatches(previousLimit);
      const nextLink = grid.children[previousLimit]?.querySelector('a');
      if (nextLink) nextLink.focus({ preventScroll: true });
    });
    window.addEventListener('popstate', () => {
      const params = new URLSearchParams(location.search);
      if (modelMode) {
        freeText = params.get('gml_text') || '';
        searchInput.value = freeText;
        applyRange(0, null, false);
        refreshLinks();
        return;
      }
      selectedSort = ['price-ascending', 'price-descending'].includes(params.get('gml_sort')) ? params.get('gml_sort') : 'featured';
      sortControl.value = selectedSort;
      Object.keys(facets).forEach(key => { facets[key] = params.get('gml_' + key + '_filter') || ''; });
      facetControls.forEach(control => { control.value = facets[control.dataset.inventoryFacet]; });
      applyRange(maxFrom(params.get('gml_min')) || 0, maxFrom(params.get('gml_max')), false);
      refreshLinks();
    });
    if (modelMode) {
      let searchTimer;
      searchInput.addEventListener('input', () => {
        clearTimeout(searchTimer);
        searchTimer = setTimeout(() => { freeText = searchInput.value; applyRange(0, null); }, 180);
      });
      searchInput.addEventListener('search', () => { freeText = searchInput.value; applyRange(0, null); });
      updateAddress();
    }
    applyRange(selectedMin, selectedMax, false);
  };
  document.querySelectorAll('[data-gml-inventory]').forEach(initialise);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-gml-inventory]').forEach(initialise));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gml-mobile-qa"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialize = () => document.querySelectorAll('[data-gml-product]').forEach((root) => {
    if (root.dataset.productReady) return;
    root.dataset.productReady = 'true';
    const main = root.querySelector('#product-main-img');
    root.querySelectorAll('[data-gml-product-thumbnail]').forEach((button) => button.addEventListener('click', () => {
      if (!main) return;
      main.removeAttribute('srcset');
      main.src = button.dataset.full;
      main.alt = button.dataset.alt;
      root.querySelectorAll('[data-gml-product-thumbnail]').forEach((item) => {
        item.classList.toggle('is-active', item === button);
        item.setAttribute('aria-pressed', item === button ? 'true' : 'false');
      });
    }));
    root.querySelector('[data-gml-product-variant]')?.addEventListener('change', (event) => {
      const url = new URL(location.href);
      url.searchParams.set('variant', event.target.value);
      location.assign(url.href);
    });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialize = () => document.querySelectorAll('[data-gml-product]').forEach((root) => {
    if (root.dataset.productReady) return;
    root.dataset.productReady = 'true';
    const main = root.querySelector('#product-main-img');
    root.querySelectorAll('[data-gml-product-thumbnail]').forEach((button) => button.addEventListener('click', () => {
      if (!main) return;
      main.removeAttribute('srcset');
      main.src = button.dataset.full;
      main.alt = button.dataset.alt;
      root.querySelectorAll('[data-gml-product-thumbnail]').forEach((item) => {
        item.classList.toggle('is-active', item === button);
        item.setAttribute('aria-pressed', item === button ? 'true' : 'false');
      });
    }));
    root.querySelector('[data-gml-product-variant]')?.addEventListener('change', (event) => {
      const url = new URL(location.href);
      url.searchParams.set('variant', event.target.value);
      location.assign(url.href);
    });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wishlist-page"]) return;
  try {
    
(() => {
  const storageKey = 'blano_favorites';
  const initialise = (scope = document) => scope.querySelectorAll('[data-gml-wishlist]').forEach(root => {
    if (root.dataset.wishReady) return;
    root.dataset.wishReady = 'true';
    const copy = JSON.parse(root.querySelector('[data-wish-copy]').textContent);
    const grid = root.querySelector('[data-wish-grid]');
    const empty = root.querySelector('[data-wish-empty]');
    const count = root.querySelector('[data-wish-count]');
    const listing = root.querySelector('[data-wish-listing]');
    const populatedIntro = root.querySelector('[data-wish-populated-intro]');
    const emptyTitle = root.querySelector('[data-wish-empty-title]');
    const savedTitle = root.querySelector('[data-wish-saved-title]');
    const notice = root.querySelector('[data-wish-notice]');
    const noticeText = root.querySelector('[data-wish-notice-text]');
    let controller;
    let generation = 0;
    let focusAfterRemove = null;
    let active = true;
    let renderedIds = new Set();
    const locale = root.dataset.locale || document.documentElement.lang || 'en';
    const route = new URL(window.Shopify?.routes?.root || root.dataset.root || '/', location.origin);
    const base = route.origin === location.origin ? route.pathname.replace(/\/?$/, '/') : '/';
    const contextKeys = ['preview_theme_id', 'preview_key', '_fd', 'pb', 'country', 'currency', 'locale'];
    function contextual(path) {
      const url = new URL(window.GmlLocale?.url(path) || path, location.origin);
      const here = new URL(location.href);
      contextKeys.forEach(key => { if (here.searchParams.has(key)) url.searchParams.set(key, here.searchParams.get(key)); });
      return url.pathname + url.search;
    }
    function node(tag, className, text) {
      const element = document.createElement(tag);
      if (className) element.className = className;
      if (text != null) element.textContent = text;
      return element;
    }
    function message(text) { noticeText.textContent = text; notice.hidden = !text; }
    function saved() {
      const parsed = JSON.parse(localStorage.getItem(storageKey) || '[]');
      if (!Array.isArray(parsed)) throw new Error('Invalid saved selection');
      const seen = new Set();
      return parsed.filter(item => {
        if (!item || typeof item !== 'object' || !/^\d+$/.test(String(item.id)) || seen.has(String(item.id))) return false;
        seen.add(String(item.id));
        return true;
      });
    }
    function handleOf(item) {
      if (typeof item.handle === 'string' && /^[a-z0-9][a-z0-9-]*$/i.test(item.handle)) return item.handle;
      try {
        const url = new URL(item.url, location.origin);
        const match = url.origin === location.origin && url.pathname.match(/\/products\/([a-z0-9][a-z0-9-]*)\/?$/i);
        return match ? match[1] : '';
      } catch { return ''; }
    }
    function imageOf(value) {
      try {
        const url = new URL(typeof value === 'string' ? value : value?.src || value?.url || '', location.origin);
        if (url.protocol !== 'https:' || !(url.hostname === location.hostname || url.hostname === 'cdn.shopify.com' || url.hostname.endsWith('.myshopify.com'))) return '';
        if (!value) return '';
        return url.href;
      } catch { return ''; }
    }
    function remove(item) {
      try {
        const parsed = JSON.parse(localStorage.getItem(storageKey) || '[]');
        if (!Array.isArray(parsed)) throw new Error('Invalid saved selection');
        const index = [...grid.children].findIndex(element => element.dataset.wishId === String(item.id));
        localStorage.setItem(storageKey, JSON.stringify(parsed.filter(entry => String(entry?.id) !== String(item.id))));
        focusAfterRemove = Math.max(0, index);
        document.dispatchEvent(new CustomEvent('gml:wishlist-change', { bubbles: true }));
      } catch { message(copy.save_error); }
    }
    function card(item, product, state) {
      const article = node('article', 'gml-wishlist__card gml-watch-card' + (state === 'loading' ? ' is-loading' : ''));
      article.dataset.wishId = String(item.id);
      const media = node('div', 'gml-wishlist__card-media');
      const handle = handleOf(item);
      const productURL = handle ? contextual(base + 'products/' + encodeURIComponent(handle)) : '';
      const title = product?.title || (locale === 'en' && typeof item.title === 'string' ? item.title : '') || copy.saved_piece;
      const source = imageOf(product?.featured_image || item.image);
      const visual = product && productURL ? node('a') : node('div');
      if (visual.tagName === 'A') { visual.href = productURL; visual.setAttribute('aria-label', title); }
      if (source) {
        const image = node('img'); image.src = source; image.alt = title; image.loading = 'lazy'; image.width = 700; image.height = 780;
        image.addEventListener('error', () => { image.replaceWith(node('span', 'gml-wishlist__missing-image', copy.no_image)); }, { once: true });
        visual.append(image);
      } else visual.append(node('span', 'gml-wishlist__missing-image', copy.no_image));
      media.append(visual);
      const removeButton = node('button', 'gml-wishlist__remove', '×');
      removeButton.type = 'button'; removeButton.setAttribute('aria-label', copy.remove_label.replace('__title__', title));
      removeButton.addEventListener('click', () => remove(item)); media.append(removeButton);
      const content = node('div', 'gml-wishlist__card-copy');
      content.append(node('p', 'gml-wishlist__vendor', product?.vendor || copy.saved_piece));
      const displayTitle = typeof product?.card_title === 'string' && product.card_title.trim() ? product.card_title.trim() : title;
      const heading = node('h3');
      if (product && productURL) { const link = node('a', '', displayTitle); link.href = productURL; link.setAttribute('aria-label', title); link.title = title; heading.append(link); } else heading.textContent = displayTitle;
      content.append(heading);
      const metadata = [];
      const reference = typeof product?.reference === 'string' ? product.reference.trim() : '';
      const year = typeof product?.year === 'string' ? product.year.trim() : '';
      if (reference && !displayTitle.toLowerCase().includes(reference.toLowerCase())) metadata.push(copy.reference.replace('[reference]', reference));
      if (year && !displayTitle.includes(year)) metadata.push(year);
      content.append(node('p', 'gml-wishlist__reference', metadata.join(' · ')));
      if (product) {
        let price = copy.on_request;
        const amount = Number(product.price);
        if (!product.inquireOnly && product.available && Number.isFinite(amount) && amount >= 0) {
          const currency = product.currency;
          try { price = new Intl.NumberFormat(locale, { style: 'currency', currency, currencyDisplay: 'code', minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(amount / 100); } catch { price = currency + ' ' + (amount / 100).toFixed(2); }
          if (product.price_varies) price = copy.from + ' ' + price;
        }
        if (product.inquireOnly || product.available) content.append(node('p', 'gml-wishlist__price', price));
        if (!product.available) content.append(node('p', 'gml-wishlist__state', copy.unavailable));
        const link = node('a', 'gml-wishlist__card-link'); link.href = productURL; link.append(node('span', '', copy.view), Object.assign(node('span', 'gml-css-arrow'), {ariaHidden: 'true'})); content.append(link);
      } else {
        content.append(node('p', 'gml-wishlist__state', state === 'missing' ? copy.unlisted : state === 'error' ? copy.load_error : copy.loading));
        if (state === 'error') { const retry = node('button', 'gml-wishlist__retry', copy.try_again); retry.type = 'button'; retry.addEventListener('click', render); content.append(retry); }
      }
      article.append(media, content); return article;
    }
    async function render() {
      const run = ++generation;
      controller?.abort(); controller = new AbortController();
      const signal = controller.signal;
      message('');
      let items;
      try { items = saved(); } catch {
        grid.replaceChildren(); grid.setAttribute('aria-busy', 'false'); empty.hidden = true; listing.hidden = true; populatedIntro.hidden = true; emptyTitle.hidden = false; savedTitle.hidden = true; count.hidden = true; root.dataset.wishState = 'error'; root.classList.remove('gml-frosted-page'); count.textContent = ''; message(copy.storage_error); return;
      }
      count.textContent = (items.length === 1 ? copy.count_one : copy.count_many).replace('__count__', String(items.length));
      empty.hidden = items.length !== 0;
      emptyTitle.hidden = items.length !== 0;
      savedTitle.hidden = items.length === 0;
      count.hidden = items.length === 0;
      listing.hidden = items.length === 0;
      populatedIntro.hidden = items.length === 0;
      root.dataset.wishState = items.length ? 'populated' : 'empty';
      root.classList.toggle('gml-frosted-page', items.length > 0);
      grid.replaceChildren(); grid.setAttribute('aria-busy', String(items.length > 0));
      if (!items.length) {
        renderedIds.clear();
        if (focusAfterRemove !== null) root.querySelector('[data-wish-heading]').focus();
        focusAfterRemove = null;
        return;
      }
      let arrival = 0;
      const cards = items.map(item => {
        const element = card(item, null, 'loading');
        if (!renderedIds.has(String(item.id))) {
          element.classList.add('is-entering');
          element.style.setProperty('--wish-delay', Math.min(arrival++, 6) * 55 + 'ms');
          element.addEventListener('animationend', () => element.classList.remove('is-entering'), { once: true });
        }
        grid.append(element);
        return element;
      });
      renderedIds = new Set(items.map(item => String(item.id)));
      if (focusAfterRemove !== null) cards[Math.min(focusAfterRemove, cards.length - 1)].querySelector('.gml-wishlist__remove').focus();
      focusAfterRemove = null;
      let index = 0;
      const worker = async () => {
        while (index < items.length && active && run === generation) {
          const current = index++; const item = items[current]; const handle = handleOf(item);
          let product = null; let state = handle ? 'missing' : 'error';
          if (handle) {
            const requestController = new AbortController();
            const abort = () => requestController.abort();
            signal.addEventListener('abort', abort, { once: true });
            const timeout = window.setTimeout(abort, 12000);
            try {
              const path = contextual(base + 'products/' + encodeURIComponent(handle) + '?view=gml-wishlist-data');
              const response = await fetch(path, { credentials: 'same-origin', signal: requestController.signal, headers: { Accept: 'text/html' } });
              if (response.ok) {
                const value = await response.json();
                if (String(value.id) === String(item.id)) {
                  if (typeof value.inquireOnly !== 'boolean' || typeof value.available !== 'boolean' || !/^[A-Z]{3}$/.test(value.currency)) throw new Error('Product details unavailable');
                  if (!value.inquireOnly && value.available && (typeof value.price !== 'number' || !Number.isFinite(value.price) || value.price < 0)) throw new Error('Product price unavailable');
                  product = value;
                }
              } else if (response.status !== 404 && response.status !== 410) state = 'error';
            } catch { if (signal.aborted) return; state = 'error'; }
            finally { clearTimeout(timeout); signal.removeEventListener('abort', abort); }
          }
          if (active && run === generation) {
            const keepFocus = cards[current].contains(document.activeElement) && document.activeElement.matches('.gml-wishlist__remove');
            const replacement = card(item, product, state);
            cards[current].replaceChildren(...replacement.childNodes);
            cards[current].classList.remove('is-loading');
            if (keepFocus) cards[current].querySelector('.gml-wishlist__remove').focus();
          }
        }
      };
      await Promise.all(Array.from({ length: Math.min(4, items.length) }, worker));
      if (active && run === generation) grid.setAttribute('aria-busy', 'false');
    }
    const onStorage = event => { if (event.key === storageKey || event.key === null) render(); };
    const onPageShow = event => { if (event.persisted) render(); };
    root.querySelector('[data-wish-retry]').addEventListener('click', render);
    window.addEventListener('storage', onStorage);
    window.addEventListener('gml:wishlist-change', render);
    window.addEventListener('pageshow', onPageShow);
    function unload(event) {
      if (!event.target.contains(root)) return;
      active = false; controller?.abort(); window.removeEventListener('storage', onStorage); window.removeEventListener('gml:wishlist-change', render); window.removeEventListener('pageshow', onPageShow); document.removeEventListener('shopify:section:unload', unload);
    }
    document.addEventListener('shopify:section:unload', unload);
    render();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialise()); else initialise();
  document.addEventListener('shopify:section:load', event => initialise(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
